<template>
  <HeaderNav
    v-if="userIsLoggedIn"
    ref="headerComponent" />
  <SideBar v-if="userIsLoggedIn" />
  <div
    id="page-container"
    :style="{ marginTop: headerHeight + 'px' }"
  >
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue';
import type { ComponentPublicInstance } from 'vue';
import { storeToRefs } from 'pinia';
import SideBar from '@/components/common/SideBar.vue';
import HeaderNav from '@/components/common/HeaderNav.vue';
import { useAuthStore } from "@/stores/useAuthStore.ts";

const authStore = useAuthStore();

const { accessToken } = storeToRefs(authStore);

const userIsLoggedIn = computed(() => !!accessToken.value);

const headerHeight = ref(0);
const headerComponent = ref<ComponentPublicInstance<{ headerRef: HTMLDivElement }>>();

const updateHeaderHeight = () => {
  if (!userIsLoggedIn.value) {
    headerHeight.value = 0;
    return;
  }

  nextTick(() => {
    const headerEl = headerComponent.value?.$refs.headerRef as HTMLDivElement | undefined;
    if (headerEl) {
      headerHeight.value = headerEl.offsetHeight;
    }
  });
};

onMounted(() => {
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateHeaderHeight);
});
</script>